module.exports = __webpack_public_path__ + "img/26_116.a9219460.png";